import api from './client';

export interface Parametros {
  id: number;
  cteMonitoramentoAtivo: boolean;
  reposicaoCalculosAtivos: boolean;
  reposicaoHorario: string;
  metabaseUrl?: string | null;
  /** Janela padrão (em meses) da Reposição. Valores válidos: 1, 2, 3, 6, 9, 12. */
  janelaAnaliseMesesDefault: number;
  atualizadoEm?: string;
}

export const parametrosApi = {
  obter: async (): Promise<Parametros> => {
    const r = await api.get<Parametros>('/parametros');
    return r.data;
  },
  salvar: async (dados: Parametros): Promise<void> => {
    await api.put('/parametros', dados);
  },
};
